<template>
  <v-avatar :size="avatarHeight">
    <img v-if="avatarFilename" :src="getPersonAvatarImage(avatarFilename)" />
    <v-icon v-else large>mdi-account-circle</v-icon>
  </v-avatar>
</template>

<script>
export default {
  props: {
    avatarFilename: {
      type: String
    },
    avatarHeight: {
      type: String,
      default: '25px'
    }
  },
  methods: {
    getPersonAvatarImage(avatar_filename) {
      return (
        'https://bannov-blog-avatars.s3.eu-central-1.amazonaws.com/' +
        avatar_filename
      )
    }
  }
}
</script>

<style></style>
